<template>
  <div>
    <AuthViewIntro
      :title="$t('profile.forgot-password')"
      :subtitle="$t('profile.forgot-pass.sub-heading')" />

    <AuthAlert v-if="errorMessage" :message="errorMessage" />

    <AuthTextField
      :value="value"
      type="email"
      autocomplete="email"
      :label="$t('profile.login.email')"
      placeholder="user@guestaps.com"
      :error="emailError"
      @input="$emit('input', $event)"
      @blur="isTouched = true"
      @enter="submit" />

    <AuthSubmitButton :disabled="!isValid" :loading="loading" @click="submit">
      {{ $t('profile.forgot-pass.send-otp') }}
    </AuthSubmitButton>
  </div>
</template>

<script>
  const { email, required } = require('vuelidate/lib/validators');
  import AuthViewIntro from '../../AuthViewIntro.vue';
  import AuthTextField from '../../AuthTextField.vue';
  import AuthSubmitButton from '../../AuthSubmitButton.vue';
  import AuthAlert from '../../AuthAlert.vue';

  export default {
    name: 'RequestOtpStep',
    components: {
      AuthViewIntro,
      AuthTextField,
      AuthSubmitButton,
      AuthAlert
    },
    props: {
      value: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      errorMessage: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isTouched: false
      }
    },
    validations: {
      value: { required, email }
    },
    computed: {
      isValid() {
        return !this.$v.value.$invalid;
      },
      emailError() {
        if (!this.isTouched) return '';
        if (!this.$v.value.required) return this.$t('profile.auth.required-field');
        if (!this.$v.value.email) return this.$t('profile.auth.invalid-email');
        return '';
      }
    },
    methods: {
      submit() {
        if (!this.isValid || this.loading) return;
        this.$emit('submit');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/v2/auth/views/forgot-password/RequestOtpStep.vue